export function handleApiError(error: any): void {
  if (error && (error.status === 401 || error.status === 403 || error.code === 14008)) {
    localStorage.clear();
    window.location.reload();
  } else {
    alert(error.message);
  }
}
